import InnerInput from './Input';
import './style/index.less';
import Search from './Search';
import TextArea from './TextArea';
import Password from './Password';
import Group from './Group';
var Input = InnerInput;
/**
 * @desc 搜索框
 * @link https://bedrock.netease.com/components/search
 */

Input.Search = Search;
/**
 * @desc 多行文本
 * @link https://bedrock.netease.com/components/input#%E5%A4%9A%E8%A1%8C%E6%96%87%E6%9C%AC%E6%A1%86
 */

Input.TextArea = TextArea;
/**
 * @desc 密码框
 * @link https://bedrock.netease.com/components/input#%E5%AF%86%E7%A0%81%E6%A1%86
 */

Input.Password = Password;
/**
 * @desc 输入框
 * @link https://bedrock.netease.com/components/input
 */

Input.Group = Group;
export default Input;